import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    eiButtonDescription: 'Entreprise Individuelle',
    eiButtonTitle: 'EI / EIRL',
    gaecButtonDescription: 'Groupement Agricole d’Exploitation en Commun',
    gaecButtonTitle: 'GAEC',
    microButtonDescription: 'Statut micro-entrepreneur (auto-entreprise)',
    microButtonTitle: 'Micro-entreprise',
    nextButtonLabel: 'Continue',
    sarlButtonDescripton: 'Société à Responsabilité Limitée',
    sarlButtonTitle: 'SARL / EURL',
    sasButtonDescription: 'Société par Actions Simplifiée',
    sasButtonTitle: 'SAS / SASU',
    saveErrorMessage: 'Please check your connection and try again',
    sciButtonDescription: 'Société Civile Immobilière',
    sciButtonTitle: 'SCI',
    scmButtonDescription: 'Société Civile de Moyens',
    scmButtonTitle: 'SCM',
    selectOption: 'Please select an option',
    sncButtonDescription: 'Société en Nom Collectif',
    sncButtonTitle: 'SNC',
    title: 'What’s the legal status of your company?',
  },
  fr: {
    eiButtonDescription: 'Entreprise Individuelle',
    eiButtonTitle: 'EI / EIRL',
    gaecButtonDescription: 'Groupement Agricole d’Exploitation en Commun',
    gaecButtonTitle: 'GAEC',
    microButtonDescription: 'Statut micro-entrepreneur (auto-entreprise)',
    microButtonTitle: 'Micro-entreprise',
    nextButtonLabel: 'Continuer',
    sarlButtonDescripton: 'Société à Responsabilité Limitée',
    sarlButtonTitle: 'SARL / EURL',
    sasButtonDescription: 'Société par Actions Simplifiée',
    sasButtonTitle: 'SAS / SASU',
    saveErrorMessage: 'Pouvez-vous vous reconnecter et réessayer\u00A0?',
    sciButtonDescription: 'Société Civile Immobilière',
    sciButtonTitle: 'SCI',
    scmButtonDescription: 'Société Civile de Moyens',
    scmButtonTitle: 'SCM',
    selectOption: 'Veuillez sélectionner une option',
    sncButtonDescription: 'Société en Nom Collectif',
    sncButtonTitle: 'SNC',
    title: 'Quel est le statut de votre entreprise\u00A0?',
  },
});
